import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { COMMUNICATION_WAY } from '../models/enums';

@Pipe({
  name: 'communicationWayFormatter',
  pure: false,
})
export class CommunicationWayFormatterPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(value: COMMUNICATION_WAY): string {
    let resultDate = this.getResult(value);

    this.translateService.onLangChange.subscribe(() => {
      resultDate = this.getResult(value);
    });

    return resultDate;
  }

  private getResult(value: COMMUNICATION_WAY): string {
    if (!value) {
      return this.translateService.instant('pipes.communication_way.no_matter');
    }
    return this.translateService.instant(`pipes.communication_way.${value}`);
  }
}
